// PLUGINS IMPORTS //
import React from "react"

// COMPONENTS IMPORTS //
import BlockItem from "./BlockItem/BlockItem"
import { EducationList } from "./Data"
import { memoComparison } from "Content/Shared/Helpers/Functions/Functions"

// EXTRA IMPORTS //

/////////////////////////////////////////////////////////////////////////////

type PropsType = {}

const EducationHistory: React.FC<PropsType> = () => {
  return (
    <div>
      {EducationList.map((item, index) => (
        <BlockItem
          education={item}
          nextExist={EducationList[index + 1] !== undefined}
        />
      ))}
    </div>
  )
}

export default React.memo(EducationHistory, memoComparison)
